import type { TrackData } from '@glovo/customer-analytics'
import type { AnalyticsDelegate, DynamicSessionType } from './analytics-multiplatform-sdk'
import type { MParticleSDK } from './types'
import { consoleLog } from '@/tools/console-log'

export class MParticleDelegate implements AnalyticsDelegate {
  private mParticleSDKInstance
  constructor(mParticleSDKInstance: MParticleSDK) {
    this.mParticleSDKInstance = mParticleSDKInstance
  }
  event(name: string, data: TrackData = {}): void {
    this.mParticleSDKInstance.logEvent(name, this.mParticleSDKInstance.EventType.Other, data)
    consoleLog.navy('mParticle', `${name}`, {
      ...data,
    })
  }

  screen(name: string, data: TrackData = {}, customFlags: Record<string, unknown> = {}) {
    this.mParticleSDKInstance.logPageView(name, data, customFlags)
    consoleLog.navy('mParticle', `${name}`, {
      ...data,
    })
  }

  onUserIdentified() {
    // TODO  https://glovoapp.atlassian.net/browse/CCEV2-4380
  }

  eCommerceEvent() {
    // TODO https://glovoapp.atlassian.net/browse/CCEV2-4380
  }
  eCommerceImpression() {
    // TODO https://glovoapp.atlassian.net/browse/CCEV2-4380
  }
  sendMetric() {
    // TODO https://glovoapp.atlassian.net/browse/CCEV2-4380
  }
  onSessionUpdated() {
    // TODO https://glovoapp.atlassian.net/browse/CCEV2-4380
  }
  onRestoreSession = (): null | DynamicSessionType => null // TODO https://glovoapp.atlassian.net/browse/CCEV2-4380
}
